import PropTypes from 'prop-types';

import {LANGUAGES} from '@/src/app/constants/course';
import {SEARCH_FILTERS} from '@/src/app/constants/search';
import FilterRow from '@/src/Search/components/FilterRow';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {CheckboxCommon, SimpleCollapse, Text} from '@/src/ui';

const LanguagesFilters = ({query, onChangeHandler}) => {
  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.languages'} />
        </Text>
      }
    >
      {LANGUAGES.map(({value}) => {
        const currentLanguageItem = LANGUAGES.find(
          (level) => level.value === value
        );

        return (
          <FilterRow key={currentLanguageItem.value}>
            <CheckboxCommon
              id={currentLanguageItem.value}
              name={currentLanguageItem.value}
              label={<TextLocal id={currentLanguageItem.label} />}
              data-filter-name={SEARCH_FILTERS.LANGUAGES}
              data-value={currentLanguageItem.value}
              checked={
                !!query[SEARCH_FILTERS.LANGUAGES] &&
                // @ts-ignore
                JSON.parse([query[SEARCH_FILTERS.LANGUAGES]]).includes(
                  currentLanguageItem.value
                )
              }
              onChange={onChangeHandler}
              isSemibold
            />
          </FilterRow>
        );
      })}
    </SimpleCollapse>
  );
};

LanguagesFilters.propTypes = {
  query: PropTypes.object.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
};

export default LanguagesFilters;
